import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import PhotoCaptureModal from '../PhotoCaptureModal';

const PhotoUploader = ({ onPhotosChange, title = "Fotos informativas (opcional)", initialPhotos = { photo1: null, photo2: null } }) => {
  const [photos, setPhotos] = useState(initialPhotos);
  const [showCameraModal, setShowCameraModal] = useState(null);
  const fileInput1Ref = useRef(null);
  const fileInput2Ref = useRef(null);

  useEffect(() => {
    if (initialPhotos && (initialPhotos.photo1 || initialPhotos.photo2)) {
      setPhotos(initialPhotos);
    }
  }, [initialPhotos]);

  const convertToBase64 = (dataURL) => {
    return dataURL.split(',')[1];
  };

  const handleFileChange = (photoKey, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = convertToBase64(e.target.result);
        const newPhotos = { ...photos, [photoKey]: base64 };
        setPhotos(newPhotos);
        onPhotosChange(newPhotos);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCameraPhoto = (dataURL) => {
    const base64 = convertToBase64(dataURL);
    const newPhotos = { ...photos, [showCameraModal]: base64 };
    setPhotos(newPhotos);
    onPhotosChange(newPhotos);
    setShowCameraModal(null);
  };

  const removePhoto = (photoKey) => {
    const newPhotos = { ...photos, [photoKey]: null };
    setPhotos(newPhotos);
    onPhotosChange(newPhotos);
  };

  return (
    <>
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>{title}</Card.Title>
          
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Foto 1</Form.Label>
                <div className="d-flex gap-2 mb-2">
                  <Button 
                    variant="outline-primary" 
                    size="sm"
                    onClick={() => fileInput1Ref.current?.click()}
                  >
                    Subir archivo
                  </Button>
                  <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={() => setShowCameraModal('photo1')}
                  >
                    Tomar foto
                  </Button>
                  {photos.photo1 && (
                    <Button 
                      variant="outline-danger" 
                      size="sm"
                      onClick={() => removePhoto('photo1')}
                    >
                      Eliminar
                    </Button>
                  )}
                </div>
                
                <input
                  ref={fileInput1Ref}
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileChange('photo1', e.target.files[0])}
                />
                
                {photos.photo1 && (
                  <img 
                    src={`data:image/jpeg;base64,${photos.photo1}`}
                    alt="Foto 1"
                    style={{ width: '100%', maxWidth: '200px', height: 'auto' }}
                    className="mt-2"
                  />
                )}
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Foto 2</Form.Label>
                <div className="d-flex gap-2 mb-2">
                  <Button 
                    variant="outline-primary" 
                    size="sm"
                    onClick={() => fileInput2Ref.current?.click()}
                  >
                    Subir archivo
                  </Button>
                  <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={() => setShowCameraModal('photo2')}
                  >
                    Tomar foto
                  </Button>
                  {photos.photo2 && (
                    <Button 
                      variant="outline-danger" 
                      size="sm"
                      onClick={() => removePhoto('photo2')}
                    >
                      Eliminar
                    </Button>
                  )}
                </div>
                
                <input
                  ref={fileInput2Ref}
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileChange('photo2', e.target.files[0])}
                />
                
                {photos.photo2 && (
                  <img 
                    src={`data:image/jpeg;base64,${photos.photo2}`}
                    alt="Foto 2"
                    style={{ width: '100%', maxWidth: '200px', height: 'auto' }}
                    className="mt-2"
                  />
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <PhotoCaptureModal
        isOpen={showCameraModal !== null}
        onClose={() => setShowCameraModal(null)}
        onPhotoTaken={handleCameraPhoto}
      />
    </>
  );
};

export default PhotoUploader;